import {Record} from 'immutable';
import User from '../domain/User';
import Token from '../domain/Token';

const State = new Record({
    /** {User} */
    user: null,

    /** {Token} */
    token: null,

    /** string */
    landPage: null,

    /** string */
    adminPage: null,
});

const LSKEY = 'sge.{7DE9C34C-4514-4D94-9F96-E45733F02A75}';

class LocalStorage {
    constructor() {
        let temp = localStorage.getItem(LSKEY);

        if (!temp) {
            this._state = new State();
            return;
        }

        temp = JSON.parse(temp);

        let user = temp.user ? new User(temp.user) : null;

        if (user && user.username && user.username.length === 0) {
            user = null;
        }

        let token = null;
        let landPage = null;
        let adminPage = null;

        if (user) {
            token = temp.token ? new Token(temp.token) : null;

            if (token && token.isBound() && token.hasExpired()) {
                token = null;
            } else {
                landPage = temp.landPage;
                adminPage = temp.adminPage;
            }
        }

        this._state = new State({
            user: user,
            token: token,
            landPage: landPage,
            adminPage: adminPage,
        });
    }

    state() {
        return this._state;
    }

    updateUser(user) {
        this._state = this._state.set('user', user && user.toJS ? user.toJS() : user);
        return this;
    }

    updateToken(token) {
        this._state = this._state.set('token', token && token.toJS ? token.toJS() : token);
        return this;
    }

    updateLandPage(landPage) {
        this._state = this._state.set('landPage', landPage);
        return this;
    }

    updateAdminPage(adminPage) {
        this._state = this._state.set('adminPage', adminPage);
        return this;
    }

    saveState() {
        let temp = this._state.toJS();
        localStorage.setItem(LSKEY, JSON.stringify(temp));
        return this;
    }
}

export default new LocalStorage();



// WEBPACK FOOTER //
// src/utils/LocalStorage.js